import React from 'react';
import { func } from 'prop-types';
import { reduceToSingleArray } from '../helpers';
import LuContentItem from '../LuContentItem';
import { useLuContentContext } from '../LuContentContext';

const VerticalContent = ({
  onItemClick
}) => {
  const {
    data
  } = useLuContentContext();
  const items = reduceToSingleArray(data);
  return /*#__PURE__*/React.createElement(React.Fragment, null, items == null ? void 0 : items.map(item => /*#__PURE__*/React.createElement(LuContentItem, {
    key: item.id,
    data: item,
    onItemClick: onItemClick
  })));
};

process.env.NODE_ENV !== "production" ? VerticalContent.propTypes = {
  onItemClick: func,
  onPreviewClick: func
} : void 0;
export default VerticalContent;